import React from "react";
import { Reorder } from 'framer-motion';
import { matchPhrases } from "../../../utils/utilities";

import AccordionItem from "../custom-visual-inspection/accordion-item";
import CustomNewItem from '../custom-general/custom-new-item';
import ItemCount from '../../blocks/item-count';
import ReorderItem from '../../common/reorderItem';
import PMIEquipmentForm, { PMIEquipment } from "../../forms/custom-pmi/pmiEquipmentForm";

import toastService from "../../../services/toastService";

interface Props {
    pmiEquipmentItems: PMIEquipment[];
    onChangePMIEquipmentItems: (items: PMIEquipment[]) => void;
}

const PMIEquipmentItems: React.FC<Props> = ({ pmiEquipmentItems, onChangePMIEquipmentItems }) => {
    const handleAddItem = (item: PMIEquipment) => {
        const itemMatch = pmiEquipmentItems.find((analysisItem) => matchPhrases(analysisItem.equipmentName, item.equipmentName));
        if (itemMatch) return toastService.error(`Equipment ${item.equipmentName} already exists!`);

        const newAnalysisItems = [...pmiEquipmentItems, item];
        onChangePMIEquipmentItems(newAnalysisItems);
    };

    const handleDeleteItem = (item: PMIEquipment) => {
        const newAnalysisItems = pmiEquipmentItems.filter((analysis) => analysis.equipmentName !== item.equipmentName);
        onChangePMIEquipmentItems(newAnalysisItems);
    };
   
    const handleEditItem = (baseItem: PMIEquipment, updatedItem: PMIEquipment) => {
        const newAnalysisItems = pmiEquipmentItems.map((analysis) => analysis.equipmentName === baseItem.equipmentName ? updatedItem : analysis);
        onChangePMIEquipmentItems(newAnalysisItems);
    };

    return ( 
        <>
            <ItemCount count={pmiEquipmentItems.length} label='PMI Equipment' />
                            
            <CustomNewItem label='Add New PMI Equipment'>
                <PMIEquipmentForm onSave={handleAddItem} />
            </CustomNewItem>
            
            <Reorder.Group className="list-unstyled" values={pmiEquipmentItems} onReorder={onChangePMIEquipmentItems}>
                {pmiEquipmentItems.map((item) => (
                    <ReorderItem key={item.equipmentName} value={item}>
                        <AccordionItem title={item.equipmentName} isActive>
                            <PMIEquipmentForm
                                initialPMIData={item}
                                onSave={(updated: PMIEquipment) => handleEditItem(item, updated)}
                                onDeleteItem={() => handleDeleteItem(item)}
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default PMIEquipmentItems;